import GtcOrPpPopUpModal from 'src/components/GtcOrPpPopUpModal.svelte';
import { home_data, profile_data, user_data } from 'src/stores/account/user';
import { network } from 'src/stores/session/native-bridge';
import { CHANGE_DATE } from 'src/constants';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';

export const GtcPpModalConfig = (): ModalConfig => {
	const networkState = get(network);
	const homeData = get(home_data);
	const profileData = get(profile_data);
	const userData = get(user_data);

	const showGTC =
		networkState !== 'offline' &&
		(profileData?.gtc
			? CHANGE_DATE.GTC > profileData?.gtc?.s || CHANGE_DATE.GTC > profileData?.gtc?.seen
			: CHANGE_DATE.GTC > userData.regts);

	const showPP =
		networkState !== 'offline' &&
		(profileData?.pp
			? CHANGE_DATE.PP > profileData?.pp?.s || CHANGE_DATE.PP > profileData?.pp?.seen
			: CHANGE_DATE.PP > userData.regts);

	const showDataAct =
		networkState !== 'offline' &&
		(homeData?.dataAct
			? CHANGE_DATE.DA > homeData?.dataAct?.s || !homeData?.dataAct?.agreed
			: CHANGE_DATE.DA > userData.regts);

	return {
		id: 'ppGtcState',
		component: GtcOrPpPopUpModal,
		props: {
			priority: 90, // High priority
			showGeneralTermsAndConditionsPopUpModal: showGTC,
			showPrivacyPolicyPopUpModal: showPP,
			showDataActPopUpModal: showDataAct,
		},
		rules: [
			{
				check: () => showGTC || showPP || showDataAct,
				expected: true,
			},
			NoPremiumVoucherCheckRule,
		],
	};
};
